import { SmIcon } from '@smiles/smiles-react-design-system';
import React from 'react';
import { HeaderTabbed } from './HeaderTabbed';

export interface IHeaderMobileProps {
  label: string;
  onIconClick: () => void;
}

export const HeaderMobile = ({ label, onIconClick, ...props }: IHeaderMobileProps) => {
  return (
    <section className="car-search-mobile-header" {...props}>
      <button className="car-search-mobile-header-return-button" type="button" onClick={onIconClick}>
        <SmIcon className="car-search-mobile-header-return-button-icon" name="keyboard_arrow_left" type="round" />
      </button>

      <label className="car-search-mobile-header-label">{label}</label>
    </section>
  );
};

HeaderMobile.Tabbed = HeaderTabbed;
